import { useState } from 'react';
import { Search } from 'lucide-react';
import Checkbox from '../../../../components/primitives/Checkbox.jsx';
import Input from '../../../../components/primitives/Input.jsx';
import Select from '../../../../components/primitives/Select.jsx';
import Switch from '../../../../components/primitives/Switch.jsx';
import Textarea from '../../../../components/primitives/Textarea.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';

const FREQUENCIES = [
  { value: 'hourly', label: 'Every hour' },
  { value: 'daily', label: 'Every day' },
  { value: 'weekly', label: 'Every week' },
  { value: 'monthly', label: 'Every month' }
];

const FormsSection = () => {
  const [frequency, setFrequency] = useState('weekly');

  return (
    <GallerySection id="forms" title="Form controls" description="Labels above fields, hints below. Errors say what is wrong and how to fix it.">
      <div className="gallery-grid">
        <Input label="Automation name" defaultValue="Overdue invoice follow-up" />
        <Input label="Search apps" placeholder="HubSpot, Gmail, Shopify" icon={Search} />
        <Input label="API key" mono defaultValue="pk_live_4f9a" hint="Find it in Stripe under Developers, API keys." />
        <Input label="Webhook URL" defaultValue="hooks.northwind" error="Enter a full URL that starts with https://" />
        <Input label="Workspace ID" mono defaultValue="ws_29c81d" disabled />
        <Select label="Runs" items={FREQUENCIES} value={frequency} onValueChange={setFrequency} hint="Times use your organization's time zone." />
      </div>
      <Textarea label="What should Pieve do?" placeholder="Every Monday, find invoices more than 30 days overdue and draft a reminder to each customer." rows={3} />
      <GalleryExample label="Checkboxes" stacked>
        <Checkbox label="Ask me before sending email" description="Pieve shows each email and waits for your approval." defaultChecked />
        <Checkbox label="Notify the team channel" />
        <Checkbox label="Select all invoices" indeterminate />
        <Checkbox label="Retry failed steps" disabled />
      </GalleryExample>
      <GalleryExample label="Switches" stacked>
        <div className="gallery-switch-list">
          <Switch label="Automation active" description="Runs on its schedule until you turn it off." defaultChecked />
          <Switch label="Email me a summary after each run" />
          <Switch label="Allow deletes in connected apps" description="Only admins can change this." disabled />
        </div>
      </GalleryExample>
    </GallerySection>
  );
};

export default FormsSection;
